import { useRef } from 'react';
/**
 * Current index (will increment every time useId is used).
 */
let index = 0;
/**
 * ID generator.
 */
export const useId = () => {
  const randomIdRef = useRef(`unset-id-${index}`);
  index += 1;
  return randomIdRef.current;
};
export default useId;
